import * as React from "react";

type Props = { beskrivelse: string, elementer: string[], skalVises: boolean }

function ListeMedBeskrivelse({beskrivelse, elementer, skalVises}: Props) {
    if(!skalVises) {
        return null;
    }
    return (
        <div>
            <p>{beskrivelse}</p>
            <ul>{elementer.map((element, index) => <li key={index} data-hj-suppress>{element}</li>)}</ul>
        </div>
    )
}

export default ListeMedBeskrivelse;
